import { TFunction } from 'i18next';
import { ISelectMultiOption, ISelectOption } from '@salecycle/ui-component-library';

export interface IStep {
  label: string;
  route: string;
  number: number;
}

export const stepRoutes: string[] = ['/user', '/access', '/role', '/summary'];

export const getSteps = (t: TFunction): IStep[] => [
  { label: t('newUser.steps.step1'), route: stepRoutes[0], number: 1 },
  { label: t('newUser.steps.step2'), route: stepRoutes[1], number: 2 },
  { label: t('newUser.steps.step3'), route: stepRoutes[2], number: 3 },
  { label: t('newUser.steps.step4'), route: stepRoutes[3], number: 4 },
];

export interface IUser {
  email: string;
  name: string;
  selectedAccessLevel?: ISelectOption<string>;
  selectedMultiSites?: ISelectMultiOption<string>[];
  selectedMultiSiteGroup?: ISelectOption<string>;
  selectedBrand?: ISelectOption<string>;
  selectedSite?: ISelectOption<string>;
  selectedRole?: ISelectOption<string>;
  rolePermissions?: string[];
}

export const defaultUser: IUser = {
  name: '',
  email: '',
};
